import React, { useState } from 'react';
import { Card, Typography, Button, message } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import colors from '../../utils/theme/colors';

const { Text } = Typography;

const TABS = [
  { key: 'curl', label: 'cURL' },
  { key: 'axios', label: 'Node.js (Axios)' },
  { key: 'python', label: 'Python' },
];

export default function CodeExampleCard({ title, codeExamples, description }) {
  const [activeTab, setActiveTab] = useState('curl');
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(codeExamples[activeTab]);
    setCopied(true);
    message.success('Copied to clipboard');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Card
      title={title}
      style={{
        marginTop: 16,
        background: colors.card,
        border: `1px solid ${colors.border}`,
      }}
      extra={
        <Button
          size="small"
          icon={copied ? <CheckOutlined /> : <CopyOutlined />}
          onClick={handleCopy}
          style={{ color: colors.muted_foreground }}
        >
          {copied ? 'Copied!' : 'Copy'}
        </Button>
      }
    >
      {description && (
        <Text style={{ color: colors.muted_foreground, display: 'block', marginBottom: 12 }}>
          {description}
        </Text>
      )}

      <div style={{ display: 'flex', gap: 4, marginBottom: 12, background: colors.muted, padding: 4, borderRadius: 8 }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '6px 12px',
              borderRadius: 6,
              border: 'none',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 500,
              background: activeTab === tab.key ? colors.primary : 'transparent',
              color: activeTab === tab.key ? '#fff' : colors.muted_foreground,
              transition: 'all 0.15s ease',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div
        style={{
          background: '#0a0a0a',
          borderRadius: 8,
          padding: 16,
          overflowX: 'auto',
          border: `1px solid ${colors.border}`,
        }}
      >
        <pre
          style={{
            margin: 0,
            color: '#e5e5e5',
            fontSize: 13,
            lineHeight: 1.6,
            fontFamily: "'Fira Code', 'Consolas', 'Monaco', monospace",
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          <code>{codeExamples[activeTab]}</code>
        </pre>
      </div>
    </Card>
  );
}
